import React from 'react';
import PropTypes from 'prop-types';

class ToggleInput extends React.Component{

    static propTypes = {
        title: PropTypes.string,
        active: PropTypes.bool,
        onChange: PropTypes.func,
        hint: PropTypes.string,
        style: PropTypes.object,
        disabled: PropTypes.bool
    };

    isActive(){
        return this.props.active;
    }

    toggle(){

        if(this.props.onChange)
            this.props.onChange(!this.props.active);


    }

    activate(check){

        if(this.props.onChange)
            this.props.onChange(check);
    }

    render() {

        const props = this.props;
        const me = this;

        return (<div style={props.style}>
            <div className="clearfix">
                <p className="pull-left">{props.title}</p>
                <label className="switch switch-3d switch-primary switch-xs pull-right">
                    <input type="checkbox" className="switch-input" disabled={props.disabled} checked={this.props.active} onChange={(evt) =>{

                        const value = evt.target.checked;
                        if(props.onChange)
                            props.onChange(!value);

                    }}/>
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                </label>
            </div>
            {props.hint && <p className="help-block">{props.hint}</p>}
            {props.children}
        </div>);
    }

}

export default ToggleInput;


// WEBPACK FOOTER //
// ./src/common/FormRenderer/Controls/ToggleInput.js